import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AdminSidebar({ collapsed }) {
  const location = useLocation();

  const menu = [
  { name: "Dashboard", path: "/admin/dashboard" }, 
  { name: "Categories", path: "/admin/categories" },
  { name: "Dealers", path: "/admin/dealers" },
  { name: "Reviews", path: "/admin/reviews" },
  { name: "Leads", path: "/admin/leads" },
];

  return (
    <div
      className="bg-dark text-white p-3"
      style={{
        width: collapsed ? "70px" : "220px",
        transition: "0.3s",
      }}
    >
      <h5 className="text-center mb-4">
        {collapsed ? "BN" : "BuildNear"}
      </h5>

      {menu.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`d-block p-2 mb-2 text-white text-decoration-none ${
            location.pathname.startsWith(item.path) ? "bg-primary rounded" : ""
          }`}
        >
          {collapsed ? item.name[0] : item.name}
        </Link>
      ))}

      <hr />

      <button
        className="btn btn-danger w-100 mt-3"
        onClick={() => {
          localStorage.clear();
          window.location.href = "/";
        }}
      >
        {collapsed ? "⎋" : "Logout"}
      </button>
    </div>
  );
}